import { get, post } from ".";

let projectDetailsPromise = {};

export const getProjectsDataApi = async () => {
  return await get(`projects`);
};

export const getAdminProjectsDataApi = async () => {
  return await get(`projects/admin`);
};

export const getProjectDetailsDataApi = async (projectId) => {
  if (projectDetailsPromise[projectId]) {
    return projectDetailsPromise[projectId];
  }
  projectDetailsPromise[projectId] = get(`projects/${projectId}/details`)
    .then((data) => {
      return data;
    })
    .finally(() => {
      projectDetailsPromise[projectId] = null;
    });
  return projectDetailsPromise[projectId];
};

// export const getProjectDetailsDataApi = async (projectId) => {
//   return await get(`projects/${projectId}/details`);
// };

export const addNewProjectApi = async (params) => {
  return await post(`projects/new-project`, params);
};

export const updateProjectApi = async (projectId, params) => {
  return await post(`projects/update-project?project_id=${projectId}`, params);
};

export const getOverAllBudgetApi = async (projectId) => {
  return await get(`projects/${projectId}/budget`);
};

export const updateOverAllBudgetApi = async (projectId, budget) => {
  return await post(`projects/${projectId}/update-budget?budget=${budget}`);
};

export const generateTrackIDApi = async () => {
  return await get(`projects/generate-track-id`);
};